import { render } from "./AdminEditPersonalInfo.vue?vue&type=template&id=b824b4c2&scoped=true&lang=pug"
import script from "./AdminEditPersonalInfo.vue?vue&type=script&lang=js"
export * from "./AdminEditPersonalInfo.vue?vue&type=script&lang=js"

import "./AdminEditPersonalInfo.vue?vue&type=style&index=0&id=b824b4c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b824b4c2"]])

export default __exports__